import isNil from 'ramda/src/isNil';

/**
 * Predicate for offer groups with a given predicate on the active offer that is not archived.
 * Generic over the offer shape so callers only need to satisfy the fields their
 * offer predicate actually reads.
 * @param predicate
 */
export const offerPredicate =
  <TOffer>(
    predicate: (offer: TOffer) => boolean,
  ): ((offerGroup: { activeOffer?: TOffer }) => boolean) =>
  (offerGroup: { activeOffer?: TOffer }): boolean =>
    !isNil(offerGroup) && !isNil(offerGroup.activeOffer) && predicate(offerGroup.activeOffer);
